export enum GroupingEnum {
  OFF = 'OFF',
  LOGICAL = 'LOGICAL',
}
